//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
} from '@hub/design-system-base'
import { HealthAndBeautyLargeSVG } from './svg'

interface HealthAndBeautyLargeIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
}

export const HealthAndBeautyLargeIcon: React.FC<HealthAndBeautyLargeIconProps> = forwardRef<
  HealthAndBeautyLargeIconProps,
  typeof ChakraIcon
>(({ boxSize = 'size-icon-sm', sx }, ref) => (
  <ChakraIcon
    ref={ref}
    boxSize={boxSize}
    as={HealthAndBeautyLargeSVG}
    sx={sx}
  />
))
